import React, {Component} from 'react';
import PropTypes from 'prop-types';

import { translate } from 'react-i18next';

import MasterLayout from '../../../layouts/MasterLayout';

import './styles/home.css';


class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.dispatch = props.dispatch;
    document.title = 'Home - Jørgen Hanssen';
  }

  componentWillMount() {
    const { t } = this.props;
    this.texts = t('page.home', {returnObjects: true});
  }

  render() {
    return (
      <MasterLayout
        io={this.props.io}
        navbarTitle={this.texts.title}
      >

        <div className='page-home-logo-container'>
          <img alt='' className='page-home-logo-image' src='logo/jorgen_hanssen.png' />
          <h1> Russelåter </h1>
        </div>


      </MasterLayout>
    )
  }
}

Home.contextTypes = {
   router: PropTypes.object
}

export default translate('translations')(Home);



// WEBPACK FOOTER //
// ./src/components/pages/user/Home.js